import { createComponent } from '@mtfe/sweet';
import tpl from './dom.html';
import style from './style.less';

const WaimaiDrawBody = (props = {}) => {
    const { value, threshold, poiListDom, isShangouModule = false } = props;

    const styleTemplate = {
        numeral_1: style.oneNumeral,
        numeral_2: style.twoNumeral,
        numeral_3: style.threeNumeral,
        default: style.threeNumeral,
    };

    const data = {
        value,
        threshold,
        poiListDom,
        isShangouModule,
    };
    if (value && value.toString().length) {
        const currentTemp = styleTemplate[`numeral_${value.toString().length}`];
        data.redBagInfo = currentTemp || styleTemplate.default;
    } else {
        data.redBagInfo = styleTemplate.default;
    }
    const events = {};
    return createComponent(tpl, { data, style }, events);
};

export default WaimaiDrawBody;
